import { Component, EventEmitter, HostListener, Inject, Input, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'hhsg-dialogbox',
  templateUrl: './dialogbox.component.html',
  styleUrls: ['./dialogbox.component.scss']
})
export class DialogBoxComponent {

  @Input() isActive: boolean;
	@Input() isForm: boolean = false;
	@Input() disableHeader: boolean = false;
	@Input() title: string;
	@Input() content: string;
	@Input() disableFooter: boolean = false;
	@Input() footer: string;
	@Input() allowEscape: boolean = false;
	@Input() allowDropDownOverflow = false;
	@Input() acceptText: string;
	@Input() rejectText: string;
	@Input() acceptCssClass: string;
	@Input() rejectCssClass: string;
	@Input() disableAccept: boolean = false;
	@Input() disableAcceptConditions: () => boolean;
	@Input() type: string = 'default';
	@Output() closeEvent: EventEmitter<string> = new EventEmitter<string>();
	@Output() acceptEvent: EventEmitter<any> = new EventEmitter<any>();
	@Output() rejectEvent: EventEmitter<any> = new EventEmitter<any>();
	dynamicHeight: string;
  
  @HostListener('document:keydown', ['$event']) onKeyDown(evt: any) {
		if (this.allowEscape && evt.key === 'Escape') {
			this.onDismiss('escape');
		}
	}
	
	@HostListener('window:resize')
	onResize() {	
		this.dynamicHeight =  (window.innerHeight-200) +"px";
	}
  
  constructor(
    public dialogRef: MatDialogRef<DialogBoxComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any) 
  {}

  ngOnInit(): void {
    this.onResize();	
  }
  ngOnChanges() {	
		if (this.disableAcceptConditions) {
			this.disableAccept = true;
		}
		else {
			this.disableAccept = false;
		}	
	}
	onAccept(): boolean {
		this.disableAccept = true;
    this.dialogRef.close({event:"accept"});
		return false;
	}
	onReject(): boolean {
		this.disableAccept = true;
    this.dialogRef.close({event:"reject"});
		return false;
	}
	private onDismiss(closeEvent: string): void {
		this.isActive = false;
		this.closeEvent.emit(closeEvent);
	}

  close(){
    this.dialogRef.close();
  }
  getIsHavingButtonEvents(acceptText: string, rejectText: string){
    return acceptText?.length > 0 || rejectText?.length > 0;
  }
}

